import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';
import { ModalService } from '@rocketfinancialcorp/rocket-ui/modal';
import { ShortIdPipe } from '@rocketfinancialcorp/rocket-ui/table';

import { AlertCreateModalComponent } from '@shared/components';
import { CardAlert, TemplateContext } from '@shared/models';
import { CardAccountActions, MccActions, fromFinancialAccount } from '@shared/store';

import { TemplateContextDirective } from '../../../directives/template-context.directive';
import { DateFormatPipe } from '../../../pipes/date-format.pipe';
import { MccDisplayPipe } from '../../../pipes/mcc-display.pipe';
import { PhonePipe } from '../../../pipes/phone.pipe';
import { DetailsItemComponent } from '../../details-item/details-item.component';
import { TextWithPlaceholderComponent } from '../../text-with-placeholder/text-with-placeholder.component';
import { CardPagesBreadcrumbsComponent } from '../card-pages-breadcrumbs/card-pages-breadcrumbs.component';

@Component({
  templateUrl: './alert-details.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RktButtonDirective,
    NgTemplateOutlet,
    TemplateContextDirective,
    CardPagesBreadcrumbsComponent,
    TextWithPlaceholderComponent,
    DetailsItemComponent,
    AsyncPipe,
    PhonePipe,
    DateFormatPipe,
    MccDisplayPipe,
    ShortIdPipe,
  ],
})
export class AlertDetailsComponent implements OnInit, OnDestroy {
  pageClassPrefix = 'alert-details-';

  alertDetailsContext?: TemplateContext<CardAlert>;

  alertDetails$ = this.store.select(fromFinancialAccount.selectCardAccountAlertDetails);
  mccItems$ = this.store.select(fromFinancialAccount.selectMccItems);

  constructor(
    private store: Store,
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(CardAccountActions.loadAlertDetails());
    this.store.dispatch(CardAccountActions.loadCardAccountDetails({}));
    this.store.dispatch(MccActions.load());
  }

  ngOnDestroy(): void {
    this.modalService.dismissAll();
  }

  onEditBtnClick(alert?: CardAlert) {
    if (!alert) {
      return;
    }

    const alertModalRef = this.modalService.open(AlertCreateModalComponent, { className: 'entity-form-modal' });

    alertModalRef.componentInstance.modalInitData(alert);

    alertModalRef.result.finally(() => {
      this.store.dispatch(CardAccountActions.loadAlertDetails());
    });
  }
}
